module.exports = __webpack_public_path__ + "img/icon_rueckgaberecht_blau.cd80cee7.svg";